import type { BookingsLoadError } from '../store/slices/bookingSlice';

/**
 * Reduces whatever `getBookingList` rejected with to the two facts the page
 * shows: the HTTP status, and the server's own message.
 *
 * `axiosBaseQuery` rejects with `{ status, data }`, where `data` is the parsed
 * body when there was one and the axios message string ("Network Error",
 * "timeout of …") when there was not. A rejection without a status therefore
 * means no response reached the browser — which is a different cause from a
 * server that answered 500, and the notice says which (CLAUDE.md, "A Failure
 * Must Never Look Like an Absence": distinguish causes on screen).
 */
/** A gateway can answer with a whole HTML page and a Lambda with a stack or
 *  SQL text; the notice shows the gist, not the dump. */
const MAX_MESSAGE_LENGTH = 300;

export const toBookingsLoadError = (err: unknown): BookingsLoadError => {
    const e = (err ?? {}) as { status?: unknown, data?: unknown };
    const status = typeof e.status === 'number' ? e.status : null;

    let message: string | null = null;
    if (typeof e.data === 'string') {
        message = e.data;
    } else if (e.data && typeof e.data === 'object') {
        const m = (e.data as { message?: unknown, msg?: unknown }).message
            ?? (e.data as { msg?: unknown }).msg;
        if (typeof m === 'string') message = m;
    }

    const trimmed = message?.trim() || null;
    const clipped = trimmed && trimmed.length > MAX_MESSAGE_LENGTH
        ? `${trimmed.slice(0, MAX_MESSAGE_LENGTH)}…`
        : trimmed;

    return { status, message: clipped };
};
